import {
  farmsDataURL,
  otherFarmsDataURL,
  plumeDataURL,
  stateShapesURL
} from "./config";
import { makeScroller } from "./scroll";
import { makeMap } from "./map";
import {
  addMapSource,
  loadDataLayers,
  updateLayerSizesOnResize,
  updateLabelsOnResize
} from "./layers";
import { handleSteps } from "./handleSteps";
import { updateMapZoomOnResize } from "./responsiveZoom";

import { getSteps } from "./steps";
import { generatePlumeIcon } from "./generatePlumeIcon";

function main(): void {
  let windowWidth = window.innerWidth;

  const smokeDiv = document.getElementById("smoke") as HTMLDivElement;
  generatePlumeIcon(windowWidth, smokeDiv);

  // initialize scrollama
  const scroller = makeScroller(".scroll-item", ".step");

  const locator = document.getElementById("g-locator-box") as HTMLDivElement;

  // initialize map class
  const map = makeMap("farms-map", getSteps(windowWidth));

  let currentStep = 0;

  // handle data sourcing on load
  map.on("load", function () {
    // add sources
    addMapSource(map, "farms", farmsDataURL);
    addMapSource(map, "other-farms", otherFarmsDataURL);
    addMapSource(map, "ohio-indiana-state", stateShapesURL);
    addMapSource(map, "plume", plumeDataURL);

    // load various layers
    loadDataLayers(map, windowWidth);
    // handle map resizing
    map.resize();
  });

  // handle map controls on step
  scroller.onStepEnter((response) => {
    currentStep = response.index;
    handleSteps(response, map, locator, windowWidth);
  });

  // handle window resize for responsive zoom
  let resizeTimeout = 0;

  window.addEventListener("resize", () => {
    // @ts-ignore
    clearTimeout(resizeTimeout);

    generatePlumeIcon(windowWidth, smokeDiv);

    resizeTimeout = window.setTimeout(() => {
      windowWidth = window.innerWidth;
      updateMapZoomOnResize(map, currentStep, windowWidth);
      updateLayerSizesOnResize(map, windowWidth);
      updateLabelsOnResize(map, windowWidth);
      map.resize();
    }, 150);
  });
}

document.addEventListener("DOMContentLoaded", main);
